function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L20 0L20 20L0 20L0 0Z",
  id: "enterprise_path_1"
}), /*#__PURE__*/React.createElement("clipPath", {
  id: "enterprise_mask_1"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#enterprise_path_1"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "enterprise-1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L20 0L20 20L0 20L0 0Z",
  id: "enterprise-1-(Background/Mask)",
  fill: "none",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#enterprise_mask_1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.3333 5.66667C10.5174 5.66667 10.6667 5.51741 10.6667 5.33333L10.6667 0.333333C10.6667 0.149251 10.5174 0 10.3333 0L0.333333 0C0.149251 0 0 0.149251 0 0.333333L0 5.33333C0 5.51741 0.149251 5.66667 0.333333 5.66667L10.3333 5.66667ZM10 0.666667L10 5L5.66667 5L5.66667 0.666667L10 0.666667ZM5 0.666667L5 5L0.666667 5L0.666667 0.666667L5 0.666667Z",
  transform: "translate(2 4)",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.3333 5.66667C10.5174 5.66667 10.6667 5.51742 10.6667 5.33333L10.6667 0.333333C10.6667 0.149251 10.5174 0 10.3333 0L0.333333 0C0.149251 0 0 0.149251 0 0.333333L0 5.33333C0 5.51742 0.149251 5.66667 0.333333 5.66667L10.3333 5.66667ZM10 0.666667L10 5L5.66667 5L5.66667 0.666667L10 0.666667ZM5 0.666667L5 5L0.666667 5L0.666667 0.666667L5 0.666667Z",
  transform: "translate(2 13)",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14 11.6667L14 2L14.3333 2C14.5174 2 14.6667 1.85075 14.6667 1.66667L14.6667 0.333333C14.6667 0.149251 14.5174 0 14.3333 0L0.333333 0C0.149251 0 0 0.149251 0 0.333333L0 1.66667C0 1.85075 0.149251 2 0.333333 2L0.666667 2L0.666667 19.6667C0.666667 19.8507 0.815918 20 1 20L19 20C19.1841 20 19.3333 19.8507 19.3333 19.6667L19.3333 12.3333L20 12.3333L20 11.6667L14.6667 11.6667L14 11.6667ZM1.33333 19.3333L1.33333 12.3333L13.3333 12.3333L13.3333 19.3333L1.33333 19.3333ZM1.33333 11.6667L1.33333 11L13.3333 11L13.3333 11.6667L1.33333 11.6667ZM1.33333 10.3333L1.33333 2L13.3333 2L13.3333 10.3333L1.33333 10.3333ZM0.666667 1.33333L0.666667 0.666667L14 0.666667L14 1.33333L1 1.33333L0.666667 1.33333ZM16.6667 16.6667L16.6667 17.3333L17.3333 17.3333L17.3333 19.3333L15.3333 19.3333L15.3333 14.3333L17.3333 14.3333L17.3333 16.6667L16.6667 16.6667ZM18 19.3333L18 14C18 13.8159 17.8507 13.6667 17.6667 13.6667L15 13.6667C14.8159 13.6667 14.6667 13.8159 14.6667 14L14.6667 19.3333L14 19.3333L14 12.3333L18.6667 12.3333L18.6667 19.3333L18 19.3333Z",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
})));

var SvgEnterprise = function SvgEnterprise(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEnterprise, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/enterprise.2e47e32c.svg";
export { ForwardRef as ReactComponent };